<template>
    <div class="container-fluid" ref="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>             
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Nome</option>
                                </select>
                            </div>
                            <div class="col-sm-8 col-md-6 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>                            
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table 
                                    :rows="lstusuarios" 
                                    :columns="columns" 
                                    :config="config" 
                                    :classes="classes"> 
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="codusu_f" slot-scope="item">
                                        {{ item.row.codusu }}
                                    </template>                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstusuarios.length}}</span>
                                    </li>
                                </ul>            
                            </div>                            
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10" id="dvpaginacao">
                                <v-pagination
                                    v-model="pagina_atual"
                                    :page-count="pqtd_paginas"
                                    :classes="bootstrapPaginationClasses">
                                </v-pagination>       
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>                               
                        </div>
                    </div>
                </div> 
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">Código:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vcodusu"
                                maxlength="20" style="text-transform: uppercase;" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="ednome">*Nome do usuário:</label>
                                <input type="text" v-model="vnomeusu" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="ednome" maxlength="50">
                            </div>                            
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edlogin">*Login:</label>
                                <input type="text" v-model="vloginusu" v-bind:disabled="opcrud > 1"
                                    class="form-control form-control-sm" id="edlogin" data-bv-group=".group" maxlength="20"
                                    style="text-transform: lowercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edsenhausu">*Senha:</label>
                                <input type="password" v-model="vsenhausu" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edsenhausu" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">*Técnico:</span>
                                <select id="cbtecnico" data-placeholder="Selecione um técnico" data-allow-clear="true"
                                        style="width:100%;" v-model="vcodtec" v-bind:disabled="ativadesativa">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="ednomeatualizador">Nome atualizador:</label>
                                <input type="text" v-model="vnomeatualizador" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="ednomeatualizador" data-bv-group=".group" maxlength="20" style="text-transform: uppercase;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edsenhaatualizador">Senha atualizador:</label>
                                <input type="password" v-model="vsenhaatualizador" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edsenhaatualizador" data-bv-group=".group" maxlength="20">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Filial padrão:</span>
                                <select id="cbfilial" v-model="vcodfil" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="edemailusu">*E-mail:</label>
                                <input type="email" v-model="vemailusu" v-bind:disabled="ativadesativa"
                                    class="form-control form-control-sm" id="edemailusu" data-bv-group=".group" maxlength="100">
                            </div>
                            <div class="col-sm-12 col-md-1 col-lg-1">
                                <label for="cbativo">Ativo:</label>
                                <select class="form-control form-control-sm" id="cbativo" v-model="vativo"
                                        v-bind:disabled="ativadesativa">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                </select>
                            </div>
                            <div class="col-md-12" style="margin-top: 15px;" v-if="opcrud > 0">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="tabperfil" data-toggle="tab" href="#dvperfil" role="tab" aria-controls="Perfil do usuário" aria-selected="true">Perfil do usuário</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabfiliais" data-toggle="tab" href="#dvfiliais" role="tab" aria-controls="Filiais" aria-selected="false">Filiais do usuário</a>
                                    </li>
                                </ul>
                                <div class="tab-content" id="dvconteudotab">
                                    <div class="tab-pane fade show active" id="dvperfil" role="tabpanel" aria-labelledby="peril-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                        <span style="font-size: 16px; font-weight: 600;">OPÇÕES DO PERFIL</span>
                                                        <i v-show="parseInt(opcrud) < 3" class="fa fa-clone" id="btclonarperfilusuario" @click.prevent="mtdchamarcopiarperfil()" data-toggle="tooltip" title="Clonar o perfil de um usuário"></i>
                                                        <i v-show="parseInt(opcrud) < 3" class="fa fa-th-list" id="btmarcartodosopusuario" @click.prevent="mtdmarcartodosopcoesusuario()" data-toggle="tooltip" title="Marcar/Desmarcar todas as opções"></i>
                                                    </li>
                                                    <template v-for="(opcao, index) in lstMenuUsuario">
                                                        <li v-if="opcao.descricao !== '-'" v-bind:key="index" @click.prevent="mtdhabilitaop(index)" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 5px 15px 5px 15px;">
                                                            <span v-bind:class="opcao.classe">{{ opcao.descricao }}</span>
                                                            <span v-if="parseInt(opcao.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                            <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tab-pane fade" id="dvfiliais" role="tabpanel" aria-labelledby="filiais-tab">
                                        <div class="row">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item text-center text-black-50" style="padding: 5px;">
                                                        <span style="font-size: 16px; font-weight: 600;">OPÇÕES DAS FILIAIS</span>
                                                        <i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodfiliais" @click.prevent="mtdmarcartodasfiliais()" data-toggle="tooltip" title="Marcar/Desmarcar todas as filiais"></i>
                                                    </li>
                                                    <template v-for="(filial, index) in lstFiliais">
                                                        <li @click.prevent="mtdhabilitafilial(index)" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 5px 15px 5px 15px;">
                                                            <span class="menuprincipal">{{ filial.fantasia }}</span>
                                                            <span v-if="parseInt(filial.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                            <span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>                    
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>   
                        </div>
                    </div>                    
                </div>                                   
            </div>    
        </div>

        <!--Clonar perfil do usuário-->
        <div class="modal fade" id="mdObterPerilUsuario">
            <div class="modal-dialog modal-sm">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Obter perfil</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <span style="margin-bottom:0px;">*Usuário:</span>
                                <select id="cbusuarioperfilcopiar" v-model="vcodusucopiarperil" v-bind:disabled="ativadesativa"
                                        data-placeholder="Selecione uma opção" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" id="btconfirmarcopiaperfil" @click.prevent="mtdconfimarcopiaperfil()" class="btn btn-primary btn-sm" role="button" style="min-width: 100px;"><i class="fa fa-check-circle"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal" style="min-width: 100px;"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'


    export default {
        name: 'cadusuarios_sac',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstusuarios  : [],
                pagina_atual : 1,
                pfiltro      : 1,
                pconteudo    : '',
                pqtdregistros: 10,
                pqtd_paginas : 0,
                pqtd_total_registros: 0,

                //variáveis do crud
                lstMenuUsuario      : [],
                lstFiliais          : [],
                opcrud              : 0,
                vcodusu             : '',
                vnomeusu            : '',
                vloginusu           : '',
                vsenhausu           : '',
                vcodtec             : null,
                vnomeatualizador    : '',
                vsenhaatualizador   : '',
                vcodfil             : null,
                vemailusu           : '',
                vativo              : 1,

                //variável para habilitação dos campos
                ativadesativa       : true,

                //variável p/ clonar perfil
                vcodusucopiarperil  : null,

                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'  
                },                
                itensbc : {                
                    item1 : {
                        titulo : 'USUÁRIOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }                
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",                    
                        row_classes: "def-col-opcoes",
                        sort: false
                    },                    
                    {
                        label: "Código",
                        name: "codusu",
                        sort: true,
                        slot_name: "codusu_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Nome",
                        name: "nomeusu",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Login",
                        name: "loginusu",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },                     
                    {
                        label: "E-mail",
                        name: "emailusu",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }                    
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }                
            }
        },        
        methods:{
            mtdmenubase(){
                let parametros      = [
                    {parametro: 'dbcliente',    valor  : window.localStorage.getItem('dbcliente')},//vself.$store.state.usuario.dbcliente},
                    {parametro: 'op',           valor  : 'menubase'}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios_sac.php');               
                return retorno;
            },            
            mtdselect2_def(){
                let vself = this;
                $("#cbtecnico").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    db: window.localStorage.getItem('dbcliente'),
                                    tb: 'tbtecnicos',
                                    c1: 'id',
                                    c2: 'nometecnico'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcodtecusu = $("#cbtecnico").val();
                });
                $("#cbfilial").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    db: window.localStorage.getItem('dbcliente'),
                                    tb: 'tbfiliais',
                                    c1: 'codfil',
                                    c2: 'descfil'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcodfil = $("#cbfilial").val();
                });                                 
                $("#cbusuarioperfilcopiar").select2({
                        id: function (e) {return e.codusu},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2sql,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    db: window.localStorage.getItem('dbcliente'),
                                    tb: 'tbusuarios',
                                    c1: 'codusu',
                                    c2: 'nomeusu'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vcodusucopiarperil = $("#cbusuarioperfilcopiar").val();
                });                
            },
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){                    
                    rfiltro = this.pconteudo === '' ? '' : ' and u.codusu='+this.pconteudo; 
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(u.nomeusu) like upper(\''+this.pconteudo+'%\')';
                }
                return rfiltro;
            },     
            mtdexecutapesquisa(){
                var vself           = this;   
                let filtro          = vself.mtdfiltropesquisa(); 
                this.pagina_atual   = 1;                   
                let parametros      = [
                    {parametro: 'dbcliente',    valor  : window.localStorage.getItem('dbcliente')},//vself.$store.state.usuario.dbcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'}, 
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios_sac.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    vself.pqtd_paginas         = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.mtdcarregausuarios(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },                   
            mtdcarregausuarios(ipagina){
                var vself       = this;                 
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();  
                let parametros  = [
                    {parametro: 'dbcliente',    valor : window.localStorage.getItem('dbcliente')},//vself.$store.state.usuario.dbcliente},
                    {parametro: 'op',           valor : 'listagem'},                        
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios_sac.php');
                retorno.then(function (response) {
                    vself.lstusuarios = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstusuarios = [];
                    loader.hide();
                });
            },            
            resetarDados() {
                util.toTop();

                this.vcodusu              = '';
                this.vnomeusu             = '';
                this.vloginusu            = '';
                this.vsenhausu            = '';
                this.vcodtec              = null;
                this.vnomeatualizador     = '';
                this.vsenhaatualizador    = '';
                this.vcodfil              = null;
                this.vemailusu            = '';
                this.vativo               = 1;

                $('#cbfilial').val(null).trigger('change');
                $('#cbtecnico').val(null).trigger('change');                              
            }, 
            mtdpreparacrud(op) {
                let vself = this;
                vself.opcrud = op;

                let respmenu = vself.mtdmenubase();
                respmenu.then(function (response) {
                    vself.lstMenuUsuario = response.data.menu;
                    vself.lstFiliais     = response.data.filiais;

                    $('#pnlista').hide();
                    vself.resetarDados();
                    $('#pncadastro').fadeIn(700);
                    vself.$nextTick(function () {
                        if (parseInt(vself.opcrud) < 3){
                            $('#ednome').focus();
                        }else{
                            $('#btgravar').focus();
                        }
                    });                    
                }).catch(function (response) {
                    console.log(response);
                    alert('Erro ao consultar registros');
                });                
            },            
            mtdcancelaredicao(){                
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
            },
            mtdnovo(){
                this.itensbc.item2.titulo = 'INCLUSÃO DE USUÁRIOS';
                this.itensbc.item1.ativo  = true;
                this.itensbc.item2.ativo  = true;
                this.ativadesativa        = false;
                this.mtdpreparacrud(1);        
            },            
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200); 
            },
            mtdlimpar_listagem(){                
                this.lstprodutos    = [];
                this.pagina_atual   = 1;
                this.filtro         = '';
                this.pqtd_total_registros   = 0;
                this.pqtd_paginas           = 0;
            },
            mtdaplicaselecao: function(valoratribuir){
                for (var i = 0; i < this.lstMenuUsuario.length; i++) {
                    this.lstMenuUsuario[i].habilita = valoratribuir;
                }
            },            
            mtdmarcartodosopcoesusuario(){
                if (util.findValInArray(this.lstMenuUsuario, 'habilita', 0)){
                    this.mtdaplicaselecao(1);
                }else{
                    this.mtdaplicaselecao(0);
                }
            },
            mtdhabilitaop(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lstMenuUsuario[index].habilita) === 0) {
                        this.lstMenuUsuario[index].habilita = 1;
                    } else {
                        this.lstMenuUsuario[index].habilita = 0;
                    }
                    if (this.lstMenuUsuario[index].classe === 'menuprincipal') {
                        var codop = this.lstMenuUsuario[index].codop;
                        i = index + 1;
                        while (this.lstMenuUsuario[i].codop.substring(0, 4) === codop) {
                            this.lstMenuUsuario[i].habilita = this.lstMenuUsuario[index].habilita;
                            if (i < this.lstMenuUsuario.length - 1) {
                                i++;
                            } else {
                                break;
                            }
                        }
                    } else if (this.lstMenuUsuario[index].classe === 'menusecundario') {
                        var cop = this.lstMenuUsuario[index].codop.substring(0, 4);//código da opção principal
                        var indcop = util.getArrayIndexForKey(this.lstMenuUsuario, 'codop', cop);

                        var codop = this.lstMenuUsuario[index].codop;
                        let i = index + 1;
                        while (this.lstMenuUsuario[i].codop.substring(0, 9) === codop) {
                            this.lstMenuUsuario[i].habilita = this.lstMenuUsuario[index].habilita;
                            if (i < this.lstMenuUsuario.length - 1) {
                                i++;
                            } else {
                                break;
                            }
                        }

                        //verifica se existem ítens com a opção principal marcada
                        var achou = false;
                        var w = indcop + 1;
                        while (this.lstMenuUsuario[w].codop.substring(0, 4) === cop) {
                            if (parseInt(this.lstMenuUsuario[w].habilita) === 1) {
                                achou = true;
                                break;
                            }
                            if (w < this.lstMenuUsuario.length - 1) {
                                w++;
                            } else {
                                break;
                            }
                        }
                        if (!achou) {
                            this.lstMenuUsuario[indcop].habilita = 0;
                        } else {
                            this.lstMenuUsuario[indcop].habilita = 1;
                        }
                    } else if (this.lstMenuUsuario[index].classe === 'itensmenusec') {
                        var codop    = this.lstMenuUsuario[index].codop.substring(0, 4);
                        var codopms  = this.lstMenuUsuario[index].codop.substring(0, 9);
                        var indprinc = util.getArrayIndexForKey(this.lstMenuUsuario, 'codop', codopms);
                        var indop    = util.getArrayIndexForKey(this.lstMenuUsuario, 'codop', codop);
                        if (parseInt(this.lstMenuUsuario[index].habilita) === 1) {
                            this.lstMenuUsuario[indprinc].habilita = 1;
                            this.lstMenuUsuario[indop].habilita    = 1;
                        } else {
                            var p = indprinc + 1;
                            var achou = false;
                            while (this.lstMenuUsuario[p].codop.substring(0, 9) === codopms) {
                                if (parseInt(this.lstMenuUsuario[p].habilita) === 1) {
                                    achou = true;
                                    break;
                                }
                                if (p < this.lstMenuUsuario.length - 1) {
                                    p++;
                                } else {
                                    break;
                                }
                            }
                            if (!achou) {
                                this.lstMenuUsuario[indprinc].habilita = 0;
                            }
                            //verifica se existem ítens com a opção principal marcada
                            var w = indop + 1;
                            while (this.lstMenuUsuario[w].codop.substring(0, 4) === codop) {
                                if (parseInt(this.lstMenuUsuario[w].habilita) === 1) {
                                    achou = true;
                                    break;
                                }
                                if (w < this.lstMenuUsuario.length - 1) {
                                    w++;
                                } else {
                                    break;
                                }
                            }
                            if (!achou) {
                                this.lstMenuUsuario[indop].habilita = 0;
                            }
                        }
                    }
                }
            },
            mtdaplicaselecaofilial: function(valoratribuir){
                for (var i = 0; i < this.lstFiliais.length; i++) {
                    this.lstFiliais[i].habilita = valoratribuir;
                }
            },            
            mtdmarcartodasfiliais(){
                if (util.findValInArray(this.lstFiliais, 'habilita', 0)){
                    this.mtdaplicaselecaofilial(1);
                }else{
                    this.mtdaplicaselecaofilial(0);
                }
            },
            mtdhabilitafilial(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lstFiliais[index].habilita) === 0) {
                        this.lstFiliais[index].habilita = 1;
                    } else {
                        this.lstFiliais[index].habilita = 0;
                    }
                }
            },
            mtdchamarcopiarperfil: function () {
                this.vcodusucopiarperil = null;
                $("#mdObterPerilUsuario").modal('show');
                $('#cbusuarioperfilcopiar').val(null).trigger('change');  
            },            
            mtdconfimarcopiaperfil: function () {
                if (this.vcodusucopiarperil === null){
                    this.$toastr.w("Usuário para a cópia do perfil deve ser informado!", "Atenção!");
                    $('#cbusuarioperfilcopiar').focus();
                    return;
                }
                if (this.vcodusu !== ""){
                    if (parseInt(this.vcodusucopiarperil) === parseInt(this.vcodusu)){
                        this.$toastr.w("Perfil não pode ser atribuído para o mesmo usuário!", "Atenção!");
                        $('#cbusuarioperfilcopiar').focus();
                        return;
                    }
                }                
                this.lstMenuUsuario = [];
                let vself           = this;
                let loader          = vself.$loading.show();
                let filtro          = " and codusu="+vself.vcodusucopiarperil;  
                let parametros  = [
                    {parametro: 'dbcliente',    valor : window.localStorage.getItem('dbcliente')},//vself.$store.state.usuario.dbcliente},
                    {parametro: 'op',           valor : 'listagem'},                        
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios_sac.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstMenuUsuario  = [];
                    vself.lstMenuUsuario  = response.data[0].menu;
                    $("#mdObterPerilUsuario").modal('hide');                   
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdgravar(){
                let vself = this;
                if (this.lstFiliais.length === 0){
                    vself.$toastr.w('Informe ao menos uma filial para o usuário ter acesso!', 'Atenção!');
                    $('.nav-tabs a[href="#dvfiliais"]').tab('show');
                    return;
                }
                if (!util.findValInArray(this.lstFiliais, 'codfil', this.vcodfil)){
                    vself.$toastr.w('Filial definida como padrão, não está na lista de permissões do usuário!', 'Atenção!');
                    $('.nav-tabs a[href="#dvfiliais"]').tab('show');
                    return;
                }
                if (parseInt(util.getValInArray(this.lstFiliais, 'codfil', this.vcodfil, 'habilita')) === 0 ){
                    vself.$toastr.w('Filial definida como padrão, não está selecionada na lista de permissões do usuário!', 'Atenção!');
                    $('.nav-tabs a[href="#dvfiliais"]').tab('show');
                    return;
                }               
                $.confirm({
                    title               : 'Confirmação!',
                    content             : 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon                : 'fa fa-question-circle',
                    escapeKey           : true,
                    backgroundDismiss   : false,
                    escapeKey           : 'nao',
                    type                : 'dark',
                    typeAnimated        : true,
                    buttons: {
                        sim: {
                            text    : '<u>S</u>im',
                            keys    : ['s', 'S'],
                            btnClass: 'btn-blue',
                            action  : function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.mtdregistro();
                            },
                        },
                        nao: {
                            text    : '<u>N</u>ão',
                            keys    : ['n', 'N'],
                            action  : function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },            
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'codusu'                : this.vcodusu,
                    'nomeusu'               : this.vnomeusu,
                    'loginusu'              : this.vloginusu,
                    'senhausu'              : this.vsenhausu,
                    'emailusu'              : this.vemailusu,
                    'codtec'                : this.vcodtecusu,
                    'codfil'                : this.vcodfil,
                    'ativo'                 : this.vativo,
                    'nomeatualizador'       : this.vnomeatualizador,
                    'senhaatualizador'      : this.vsenhaatualizador,
                    'percdescjuros'         : this.vpercdescjuros,
                    'percdescmulta'         : this.vpercdescmulta,
                    // 'carddemorecdesp'       : this.vcarddemorecdesp    === false ? 0 : 1,
                    // 'cardminhasvisitas'     : this.vcardminhasvisitas  === false ? 0 : 1,
                    'menu'                  : this.lstMenuUsuario,
                    'filiais'               : this.lstFiliais
                };
                let parametros      = [
                    {parametro: 'op',       valor : 'rotinacrud'}, 
                    {parametro: 'opcrud',   valor : vself.opcrud},
                    {parametro: 'registro', valor : JSON.stringify(registrocrud)},                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadusuarios_sac.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltro       = 0;
                        vself.pconteudo     = vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregausuarios(1);
                    }else{
                        vself.$toastr.w(response.data, 'Atenção!');
                    }                    
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            }            
        },
        mounted: function () {
            $('#pnlista').fadeIn(700);
            this.mtdselect2_def();
        },
        computed:{
            validou() {
                return this.vnomeusu === '' || this.vloginusu === '' || this.vsenhausu === '' || this.vemailusu === "" || this.vcodtecusu === null || this.vcodfil === null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregausuarios(val);
            }
        }        
    }               
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    } 
</style>